import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { PanelProps } from './Panel.props';

export const Panel: React.FC<PanelProps> = ({
  title,
  actions,
  children,
  sx,
}) => {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'v4.border',
        borderRadius: 2,
        overflow: 'hidden',
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: '14px',
          py: '10px',
          borderBottom: 1,
          borderColor: 'v4.border',
        }}
      >
        <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>
          {title}
        </Typography>
        {actions && <Box>{actions}</Box>}
      </Box>
      <Box sx={{ p: '12px 14px' }}>{children}</Box>
    </Box>
  );
};
